import { OrderResponse } from "@omni/types/api/cart/bff/order.response";

export const $OrderDetailModuleName = "orderDetail";

export type TOrderDetailsState = OrderResponse;
